<template>
<div>
<!-- 账号密码登录 -->
<el-form class="login-form">
  <el-form-item>
    <sw-input v-model="username" size="default" :placeholder="config.netidPlaceholder" circular @blur="checkInput(username)">
      <i slot="prefix"  class="su-input-icon black su-input-icon-prefix el-input__icon su-icon-people"></i>
    </sw-input>
    </el-form-item>
  <el-form-item class="relative">
    <sw-input v-model="password" size="default" placeholder="请输入登录密码" circular show-password @keyup.enter.native="login(username, password,captcha,rememberMe)">
      <i slot="prefix" class="su-input-icon black su-input-icon-prefix el-input__icon su-icon-lock"></i>
    </sw-input>
    <div class="login-error" v-if="loginError">
      {{loginError}}
    </div>
  </el-form-item>

  <el-form-item>
    <el-button @click="login(username, password, captcha, rememberMe)" class="login-btn" size="default" style="width: 100%" type="primary" native-type="button" round>登 录</el-button>
  </el-form-item>

</el-form>
  <!-- 验证码弹框 -->
  <el-dialog
    class="captcha-dialog-wrapper"
      :visible.sync="captchaDialogVisible"
      modal-append-to-body="true"
      append-to-body="true"
      width="450px"
      title="访问验证"
      @close="closeCaptcha">
      <div  class="captcha-dialog-wrap">
        <div class="captcha-tip">您的操作疑似异常，请输入图形验证码</div>
        <el-input class="input-style" v-model="captcha"></el-input>
        <div class="captcha-img-wrap">
          <img :src="captchaImgUrl" alt="">
          <sw-button type="text" :style="{color:`#${config.schemeColor}`}" @click="refreshCaptcha">看不清楚？换一张</sw-button>
        </div>
        <div class="captcha-btn">
          <sw-button :style="{color:`#${config.schemeColor}`,borderColor:`#${config.schemeColor}`}" size="small" type="primary" simple round @click="captchaDialogVisible=false">取消</sw-button>
          <sw-button :style="{color:`#fff`,backgroundColor:`#${config.schemeColor}`,borderColor:`#${config.schemeColor}`}" size="small" type="primary"  round @click="captchaLogin(username, password,captcha,rememberMe)">提交</sw-button>
        </div>
      </div>
    </el-dialog>
</div>
</template>

<script>
export default {
  props: [
    'i18n',
    'config',

    'captchaEnabled',
    'captchaImgUrl',
    'isCaptchaShow',

    'username', 
    'password', 
    'captcha',
    'rememberMe',

    'loginError',
  ],
  data: function data() {
    return {
      captchaDialogVisible:false
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
    login: function login(username, password, captcha, rememberMe) {
      if(this.captchaEnabled&&this.isCaptchaShow) {
        this.captchaDialogVisible = true
      }else {
        this.passwordLogin(username, password,captcha,rememberMe)
      }
    },
    captchaLogin: function captchaLogin(username, password,captcha,rememberMe) {
      this.passwordLogin(username, password,captcha,rememberMe)
      this.captchaDialogVisible = false
    },
    closeCaptcha: function closeCaptcha() {
      this.isCaptchaShow = false
    },
		checkInput: function checkInput(username){
			var reg = /^[0-9]+$/;
			var  numRe = new RegExp(reg);
			if(numRe.test(username)){
				let len = username.length;
				let addNum = 0;
				let addStr = '';
				if(len<11){
					addNum = 11 - len;
					for(let i=0;i<addNum;i++){
						addStr += '0'
					}
					this.username = addStr + this.username
				}
			}
		}
  }
}
</script>
